<script setup lang="ts">
import { computed } from 'vue';

import Header6 from '@/components/base/typography/Header6.vue';
import { brandingColorsByCategory } from '@/utils/brandingColorsByCategory';
import { LargeMenu } from '@/utils/navMenu';

const props = defineProps<{
  activeState?: 'active' | 'suppressed';
  header: LargeMenu['header'];
}>();

const decorationColor = computed(
  () => brandingColorsByCategory[props.header.text]?.decoration || 'decoration-black',
);
</script>

<template>
  <div class="flex items-center" :class="{ 'opacity-50': activeState === 'suppressed' }">
    <img v-if="header.icon" class="w-5 h-5" alt="featured" :src="header.icon" />
    <Header6
      class="hover:underline decoration-4 underline-offset-8"
      :class="[{ underline: props.activeState === 'active' }, decorationColor]"
      :style="{ color: header.color }"
    >
      {{ header.text }}
      <span class="sr-only">Press arrowdown key to enter submenu</span>
    </Header6>
  </div>
</template>
